var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"header-order-status outline",on:{"click":function($event){return _vm.$popup.show('modal-status-order')}}},[_vm._t("default"),_c('span',{staticClass:"header-order-status__text"},[_vm._v("Статус заказа")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }